<template>
  <div id="login">
    <div class="login-box">
      <div class="title">用户登陆</div>
      <div class="form-box">
        <div class="form-item">
          <div class="label">用户名:</div>
          <div class="value">
            <input class="input" v-model="user" placeholder="请输入登陆用户名" />
          </div>
        </div>
        <div class="form-item">
          <div class="label">用户密码:</div>
          <div class="value">
            <input class="input" v-model="pwd" placeholder="请输入用户密码" />
          </div>
        </div>
      </div>
      <div class="login-btn pointer-hover" @click="loginTap">立即登陆</div>
      <div class="guide-register pointer-hover" @click="registerTap">还未注册？快去注册吧！</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IMG: this.img_host,
      user: '',
      pwd: ''
    }
  },
  // 页面创建前
  beforeCreate() {
    // document.querySelector('body').setAttribute('style', 'background:#f7f7f7');
  },
  mounted() {},
  methods: {
    loginTap(tap) {
      if (!this.user) {
        this.warning('用户名不能为空');
        return;
      }
      if (!this.pwd) {
        this.warning('密码不能为空');
        return;
      }
      this.warning('用户名或密码错误，请重新输入');
    },
    warning(msg) {
      this.$message({
        message: msg,
        type: 'error'
      });
    },
    registerTap() {
      this.$router.push({ name: 'register' })
    }
  }
}

</script>
<style scoped>
#login {
  display: flex;
  justify-content: center;
}
.login-box {
  background: #fff;
  width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 80vh;
  margin-top: 10px;
  padding-top: 200px;
  box-sizing: border-box;
}
.title {
  font-size: 20px;
  color: #111;
  font-weight: 600;
  padding-bottom: 20px;
}
.form-box .form-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.form-item .label {
  width: 40%;
  text-align: right;
  padding-right: 16px;
  color: #333;
  font-size: 14px;
}
.form-item .value input {
  border: none;
  width: 300px;
  height: 40px;
  font-size: 14px;
  padding-left: 10px;
  outline: none;
}
.form-item .value {
  border: 1px solid #eee;
  border-radius: 4px;
}
.login-btn {
  font-size: 18px;
  width: 200px;
  height: 50px;
  background: #3889fc;
  color: #fff;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}
.guide-register {
  font-size: 12px;
  color: #3889fc;
  margin-top: 10px;
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue